module.exports = __webpack_public_path__ + "img/blade_of_alacrity.4f2356bc.png";